import React from "react";

import "../../assets/styles/style_pgi.scss";

export default function FaqsAudit({ faqs }) {
  return (
    <div className="pgi__sidebar-slides">
      <form className="basePgi__vista-edit-gral">
        <div className="input-group my-2">
          <small className="d-block w-100">Nombre de la categoría</small>
          <input
            type="text"
            className="form-control"
            name={`category`}
            placeholder="Ingrese el nombre"
            defaultValue={faqs?.category}
            maxLength={90}
            minLength={2}
            readOnly
          />
        </div>
        <fieldset className="pgi__sidebar-container-items">
          <div className="pgi__archivo pgi__install faqs-audit">
            {faqs?.faq?.map((item, i) => {
              return (
                <div className="mx-3 faqs-audit__items">
                  <label htmlFor="title">{i + 1}</label>
                  <div key={item?._id}>
                    <div className="input-group my-2 question">
                      <small className="d-block w-100">Pregunta</small>
                      <input
                        type="text"
                        className="form-control"
                        name={`question`}
                        placeholder="Question"
                        id={i}
                        defaultValue={item?.question}
                        maxLength={150}
                        minLength={2}
                        readOnly
                      />
                    </div>
                    <div className="input-group my-2 answer">
                      <small className="d-block w-100">Respuesta</small>
                      <div
                        id={i}
                        name={"answer"}
                        dangerouslySetInnerHTML={{ __html: item.answer }}
                      ></div>
                    </div>
                  </div>
                  <hr />
                </div>
              );
            })}
          </div>
        </fieldset>
      </form>
    </div>
  );
}
